export default __webpack_public_path__ + "static/media/9.da800f10.jpg";